"use strict";
/**
 * The function getting the language part of the locale.
 *
 * @param {string} locale The locale.
 * @returns {string} The language part of the locale.
 */

module.exports = function (locale) {
  return locale.split("_")[0];
};
//# sourceMappingURL=getLanguage.js.map
//# sourceMappingURL=getLanguage.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/yoastseo/js/helpers/getLanguage.js
// module id = 21
// module chunks = 0